module.exports = __webpack_public_path__ + "media/customizations/lifeatkiawahriver/logo-b54c00a11767e3a4ea6876f4018d7744.png";